import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const location = useLocation();
  const isMainFeed = location?.pathname === '/main-feed';

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-card shadow-sm transition-therapeutic">
      <div className="container mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-[60px] lg:h-[60px]">
          <Link 
            to="/" 
            className="flex items-center gap-3 focus-ring rounded-md transition-therapeutic hover:opacity-80 press-scale"
            aria-label="OnlyCuts - Return to Landing Page"
          >
            <div className="flex items-center justify-center w-10 h-10 lg:w-12 lg:h-12 bg-primary/10 rounded-lg transition-therapeutic">
              <Icon 
                name="Heart" 
                size={24} 
                color="var(--color-primary)" 
                strokeWidth={2}
              />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-xl lg:text-2xl font-heading font-semibold text-foreground">
                OnlyCuts
              </h1>
              <p className="caption text-muted-foreground -mt-1">
                Safe space for support
              </p>
            </div>
          </Link>

          <nav className="flex items-center gap-4" aria-label="Main navigation">
            {!isMainFeed && (
              <Link
                to="/main-feed"
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-foreground hover:text-primary transition-therapeutic focus-ring rounded-md"
              >
                <Icon name="Home" size={18} />
                <span className="hidden sm:inline">Feed</span>
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;